import { createFileRoute } from '@tanstack/react-router';

import { requireRoute } from '@/router/guards';
import LaboratoryEdit from '@/ui/pages/LaboratoryEdit/LaboratoryEdit';

export const Route = createFileRoute('/_dashboard/laboratories/$id/edit')({
  beforeLoad: requireRoute('/laboratories/$id/edit'),
  component: LaboratoryEdit,
});
